import React from 'react';

import { observer } from 'mobx-react';

import { useStore } from 'utils/hooks/store';

import { findUnit, shortUnitName, unitPath } from 'containers/OrganisationStructure/types';

import { NoUnit, UnitPathText } from './styles';

/** The Unit column on the Sites list: the unit's short name, with the full path on hover. */
const SiteUnitCell: React.FunctionComponent<{ unitUuid: string | null }> = ({ unitUuid }) => {
  const { organisationStructure } = useStore();
  const units = organisationStructure.tree;

  if (!unitUuid || !findUnit(units, unitUuid)) return <NoUnit>No unit</NoUnit>;
  return <UnitPathText title={unitPath(units, unitUuid)}>{shortUnitName(units, unitUuid)}</UnitPathText>;
};

export default observer(SiteUnitCell);
